type SkipToMainProps = {
  /** Must match the `id` on the page's primary `<main>` landmark. */
  targetId?: string;
  label?: string;
};

/**
 * WCAG 2.4.1 — bypass block for repeated navigation chrome.
 * Visible on keyboard focus only.
 */
export function SkipToMain({ targetId = "main-content", label = "Skip to main content" }: SkipToMainProps) {
  return (
    <a
      href={`#${targetId}`}
      className="fixed left-4 top-4 z-[10060] -translate-y-[200%] rounded-md bg-primary px-4 py-2.5 text-sm font-semibold text-primary-foreground shadow-lg transition-transform focus:translate-y-0 focus-visible:translate-y-0 focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
    >
      {label}
    </a>
  );
}
